module.exports = __webpack_public_path__ + "static/img/71-2.b2678f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/71-2.jpg
// module id = 4jEG
// module chunks = 0